import BttfAxios from '@features/utils/axios';

const CelsiusQuizService = {
  completeCelsiusQuiz: async (data: object) =>
    await BttfAxios.post(
      `/api/celsius/quizzes/`,
      data,
      (resp) => {
        return 'success';
      },
      (err) => {
        return 'failure';
      }
    ),
};

Object.freeze(CelsiusQuizService);
export default CelsiusQuizService;
